import React from 'react';
import Header from 'components/ui/Header';
import HeroSection from './components/HeroSection';
import TeamMetrics from './components/TeamMetrics';
import TeamMembers from './components/TeamMembers';
// import ExpertiseFilter from './components/ExpertiseFilter';
import TeamCulture from './components/TeamCulture';
// import JoinTeamSection from './components/JoinTeamSection';
import CTASection from './components/CTASection';

const OurTeamPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#D93B34]/5 via-white to-amber-50/30">
      <Header />
      <HeroSection />
      <div className="bg-gradient-to-br from-gray-50/80 via-white/90 to-amber-50/50">
        <TeamMetrics />
        <TeamMembers />
        {/* <ExpertiseFilter /> */}
        <TeamCulture />
        {/* <JoinTeamSection /> */}
      </div>
      <CTASection />
    </div>
  );
};

export default OurTeamPage;